import { createElement, Fragment, FunctionComponent, useEffect, useRef } from 'react';

import { SyncClient } from '@paragon/sync-client';

import { useAppSelector } from './components/hooks';
import { getSyncConfigurations } from './store/selectors/synchronizationSelectors';

let syncClient: SyncClient | null = null;
export function getSyncClient() {
  return syncClient!;
}

export const initializeSyncClient = (serverUrl: string) => {
  syncClient = new SyncClient({ serverUrl });
  return syncClient;
};

export const SyncClientManager: FunctionComponent<{ client: SyncClient }> = (props) => {
  const configurations = useAppSelector(getSyncConfigurations);

  // Used to prevent multiple configurations from applying if the connection is delayed.
  const latestConfigurationId = useRef(1);

  useEffect(() => {
    const configurationId = latestConfigurationId.current + 1;
    latestConfigurationId.current = configurationId;

    props.client.whenReady.then(() => {
      if (latestConfigurationId.current === configurationId) {
        props.client.state.configurations = configurations;
      }
    });
  }, [configurations, props.client.state, props.client.whenReady]);

  return createElement(Fragment);
};
